export const scrollTo = () => {
    window.scrollTo(0, 0);
};
